/**
 * Upgrade legacy confirmation index.html (pre FORGE-412) at runtime so
 * checkoutconfirmationgifts and the 2-column layout work without waiting
 * for a full Magellan re-generation on S3.
 */
export function isConfirmationPagePath(pathname = window.location.pathname) {
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  return path.endsWith("/confirmation");
}

export function upgradeConfirmationPageTemplate(html) {
  if (!html || typeof html !== "string") {
    return html;
  }

  let upgraded = html;

  if (
    !upgraded.includes("checkoutconfirmationgifts") &&
    upgraded.includes("checkoutorderrecap")
  ) {
    upgraded = upgraded.replace(
      /class="container py-4"/,
      'class="container py-4 vg-confirmation-page"',
    );

    const legacyBlock =
      /<div class="py-5">\s*<span class="subscribe_text">[\s\S]*?<\/span>\s*<div class="checkout-summary">([\s\S]*?)<\/div>\s*<checkoutextrasell\s*\/?>\s*<\/div>/;

    if (legacyBlock.test(upgraded)) {
      upgraded = upgraded.replace(
        legacyBlock,
        `<div class="vg-confirmation-main py-5">
                <span class="subscribe_text">
                    <checkoutconfirmationtitle />
                </span>
                <div class="row row-1 vg-confirmation-grid">
                    <div class="col-lg-6 vg-confirmation-col vg-confirmation-col--recap">
                        <section
                            class="vg-confirmation-panel order-summary vg-confirmation-panel--recap checkout-summary"
                            aria-label="Récapitulatif de commande"
                        >
$1
                        </section>
                    </div>
                    <checkoutconfirmationgifts />
                </div>
                <section class="vg-confirmation-panel vg-confirmation-panel--extrasell">
                    <checkoutextrasell />
                </section>
            </div>`,
      );
    } else if (upgraded.includes('<div class="checkout-summary">')) {
      upgraded = upgraded.replace(
        "</div>\n                <checkoutextrasell",
        `</div>
                    <checkoutconfirmationgifts />
                <checkoutextrasell`,
      );
    }
  }

  return injectThankYouRichContent(upgraded);
}

const THANK_YOU_RICH_CONTENT_SECTION = `<section class="vg-confirmation-panel vg-confirmation-panel--thankyou-content">
                    <checkoutthankyourichcontent />
                </section>`;

function injectThankYouRichContent(html) {
  if (html.includes("checkoutthankyourichcontent")) {
    return html;
  }

  const extrasellSection =
    /(<section class="vg-confirmation-panel vg-confirmation-panel--extrasell">\s*<checkoutextrasell\s*\/?>\s*<\/section>)/;
  if (extrasellSection.test(html)) {
    return html.replace(
      extrasellSection,
      `$1
                ${THANK_YOU_RICH_CONTENT_SECTION}`,
    );
  }

  if (html.includes("<checkoutextrasell")) {
    return html.replace(
      /<checkoutextrasell\s*\/?>/,
      `<checkoutextrasell />
                ${THANK_YOU_RICH_CONTENT_SECTION}`,
    );
  }

  return html;
}
